const initialState ={
    data:[],
    reportdata:[],
  }
  const DFundManagerRReducers =(state = initialState, action: any) => {
    switch (action.type) {
      case 'FETCH_DATA_SUCCESS':
        return { ...state, data: action.payload };
        case 'FETCH_REPORT_DATA_SUCCESS':
        return { ...state, reportdata: action.payload };
        
      default:
        return state;
    }
  };
  export default DFundManagerRReducers;